import one from '../assets/svg/projects/one.png'
import two from '../assets/svg/projects/two.png'
import three from '../assets/svg/projects/three.png'
import four from '../assets/svg/projects/four.png'
import five from '../assets/svg/projects/five.png'
import six from '../assets/svg/projects/six.png'
import seven from '../assets/svg/projects/seven.png'
// import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Disease Prediction Using Machine Learning Models',
        projectDesc: "Developed and evaluated machine learning models, achieving 73% accuracy with SVM and selecting it as the best model for prediction.",
        tags: ['ML Models', 'SVM', 'Random Forest'],
        code: 'https://github.com/somyarao/Disease-Prediction-Using-Machine-learning-models-',
        demo: 'https://github.com/somyarao/Disease-Prediction-Using-Machine-learning-models-',
        image: one
    },
    {
        id: 2,
        projectName: 'De novo transcriptome assembly',
        projectDesc: 'Developed a robust pipeline for de novo transcriptome assembly, improving RNA-Seq read quality and identifying differentially expressed genes, enhancing the accuracy of gene expression analysis.',
        tags: ['RNA-Seq Data Analysis', 'Gene Expression Profiling','De Novo'],
        code: 'https://github.com/NU-Bioinformatics/fp_f2022_binf6308_sec3-somyarao',
        demo: 'https://github.com/NU-Bioinformatics/fp_f2022_binf6308_sec3-somyarao',
        image: two
    },
    {
        id: 3,
        projectName: 'Phylogenetic Analysis Of Influenza virus',
        projectDesc: "This project aims to find evolutionary relationship of Neuraminidase protein of influenza virus",
        tags: ['Blast', 'Phylogenetic analysis'],
        code: 'https://docs.google.com/document/d/18xZVB1JbwxkP20GuN_snvUPIXX6zhsTxwCD_WTLnFWQ/edit?tab=t.0',
        demo: 'https://docs.google.com/document/d/18xZVB1JbwxkP20GuN_snvUPIXX6zhsTxwCD_WTLnFWQ/edit?tab=t.0',
        image: three
    },
    // {
    //     id: 4,
    //     projectName: 'Enhancing Bankruptcy Prediction',
    //     projectDesc: 'This study develops a predictive model using financial ratios and metrics to assess firm bankruptcy likelihood.',
    //     tags: ['SAS EM', 'Gradient Boosting','HP Neural','Logistic Regression'],
    //     code: 'https://github.com/srujanakalyadapu/Enhancing-Bankruptcy-Prediction',
    //     demo: 'https://docs.google.com/presentation/d/1o5HZDJlMkavhln-lb_ciEn_44Aol-4zM/edit?usp=sharing&ouid=113398017461945714807&rtpof=true&sd=true',
    //     image: four
    // },
    // {
    //     id: 5,
    //     projectName: 'Causality of Airbnb Superhost Status',
    //     projectDesc: 'This project aims to assess the Super host badge impact on Airbnb occupancy rates in Chicago, utilizing statistical methods to optimize pricing and enhance revenue.',
    //     tags: ['Python', 'DID Regression','Clustering'],
    //     code: 'https://github.com/srujanakalyadapu/Causality-of-Airbnb-Superhost-effect',
    //     demo: 'https://docs.google.com/presentation/d/1M7nkQB9BOnbUU0Nxenw4hbb4nc2MHFK5/edit?usp=sharing&ouid=113398017461945714807&rtpof=true&sd=true',
    //     image: five
    // },
    // {
    //     id: 6,
    //     projectName: 'NBA Fantasy Lineup Optimization',
    //     projectDesc: 'This project employs advanced analytics and optimization techniques to build high-performance NBA fantasy lineups that optimizes player performance for enhanced fantasy sports results.',
    //     tags: ['Python','Machine learning','Integer programming','Dynamic Programming'],
    //     code: 'https://github.com/srujanakalyadapu/DFS-Lineup-Optimization',
    //     demo: 'https://drive.google.com/file/d/1j-yhfpj38PunSzcklEc5gD2Zspp2WwSp/view?usp=sharing',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Health Insurance Pricing and Risk Analysis',
    //     projectDesc: 'This project analyzes US health insurance costs, examining the impact of preexisting conditions, diet, and lifestyle on premiums and risk profiles to aid insurers in developing customized pricing strategies.',
    //     tags: ['Tableau'],
    //     code: 'https://github.com/srujanakalyadapu/Health-Insurance-Pricing-and-Risk-Analysis',
    //     demo: 'https://docs.google.com/presentation/d/1tpapdSk1L49XBjdrixW6WQHqC0JqIThK/edit?usp=sharing&ouid=113398017461945714807&rtpof=true&sd=true',
    //     image: seven
    // },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/